export default "<custom-list [dataSource]='billSource' [displayedColumns]='displayedColumns'></custom-list>"